"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWifiOffOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.wifi-off_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "wifi-off_outline_svg__transparent_box" },
            React.createElement("path", { className: "wifi-off_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "wifi-off_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "wifi-off_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M16 24a2.52 2.52 0 00-2 1l2 2 2-2a2.52 2.52 0 00-2-1zM5.74 16.74l1.42 1.42a11.48 11.48 0 015.26-3.58l2.52-2.52a13.52 13.52 0 00-9.2 4.68z" }),
            React.createElement("path", { d: "M26 8.8l4-4V2L2 30h2.82l9.83-9.83a5.47 5.47 0 015.91 2.27L22 21a7.47 7.47 0 00-5.23-2.95l3.29-3.29a11.44 11.44 0 014.78 3.4l1.42-1.42a13.7 13.7 0 00-4.67-3.51l3-3a17.4 17.4 0 014.53 3.65l1.38-1.38A20 20 0 0026 8.8zM2 30zM16 6a19.45 19.45 0 00-14.5 6.5l1.42 1.42A17.44 17.44 0 0116 8a16.54 16.54 0 012.75.25l1.72-1.72A19.33 19.33 0 0016 6z" }))));
}
exports.default = SvgWifiOffOutline;
//# sourceMappingURL=WifiOffOutline.js.map